// assets/taufkerze-beschriftung.js
//
// Zeigt bei Taufkerzen live an, was die Beschriftung kosten wird,
// und legt beim Hinzufügen zum Warenkorb automatisch die passende
// Menge des Zusatzprodukts "Beschriftung pro Buchstabe / Zahl"
// (CHF 1.20/Stück, SKU BESCHRIFTUNG-01) mit dazu.
//
// Zählweise: nur Buchstaben und Zahlen zählen.
// Leerzeichen, Punkte, Kommas, Bindestriche usw. sind gratis.
//
// Version 5: Kerze und Beschriftung gehen in EINER einzigen Anfrage
// an Shopify. Dadurch erscheinen beide Positionen gleichzeitig,
// ohne spürbare Verzögerung.

const BESCHRIFTUNG_VARIANT_ID = 54376315814221; // SKU BESCHRIFTUNG-01, CHF 1.20
const PREIS_PRO_ZEICHEN = 1.2; // CHF
const FELDNAME = 'properties[Beschriftungstext]';
const LOG = '[Beschriftung]';

// Gezählt werden nur Buchstaben und Zahlen. Alles andere – Leerzeichen,
// Punkte, Kommas, Bindestriche, Apostrophe – ist gratis.
// \p{L} = jeder Buchstabe (auch ä, ö, ü, é), \p{N} = jede Ziffer.
function zeichenZaehlen(text) {
  return ((text || '').match(/[\p{L}\p{N}]/gu) || []).length;
}

function preisFormatieren(betrag) {
  return betrag.toLocaleString('de-CH', { style: 'currency', currency: 'CHF' });
}

function findeEingabefeld() {
  return document.querySelector('[name="' + FELDNAME + '"]');
}

/* ------------------------------------------------------------------ */
/* 1. Live-Preisvorschau unter dem Textfeld                            */
/* ------------------------------------------------------------------ */

function initPreisvorschau() {
  const input = findeEingabefeld();
  if (!input) {
    console.log(LOG, 'Kein Beschriftungsfeld auf dieser Seite.');
    return;
  }

  const anzeige = document.createElement('p');
  anzeige.className = 'js-beschriftung-preis';
  anzeige.style.cssText = 'margin-top:.5em;font-size:0.9em;opacity:.85;';
  input.closest('.__field')?.insertAdjacentElement('afterend', anzeige) ??
    input.insertAdjacentElement('afterend', anzeige);

  function aktualisieren() {
    const anzahl = zeichenZaehlen(input.value);
    if (anzahl === 0) {
      anzeige.textContent = '';
      return;
    }
    const preis = anzahl * PREIS_PRO_ZEICHEN;
    anzeige.textContent =
      anzahl + ' Zeichen × ' + preisFormatieren(PREIS_PRO_ZEICHEN) + ' = ' + preisFormatieren(preis) + ' Aufpreis';
  }

  input.addEventListener('input', aktualisieren);
  aktualisieren();
  console.log(LOG, 'Preisvorschau aktiv.');
}

/* ------------------------------------------------------------------ */
/* 2. Beschriftung in dieselbe Warenkorb-Anfrage einbauen              */
/* ------------------------------------------------------------------ */

function cartAddUrl() {
  return (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
}

// Liest alle "properties[...]"-Felder aus dem Formular-Datensatz.
function eigenschaftenLesen(formData) {
  const eigenschaften = {};
  for (const [schluessel, wert] of formData.entries()) {
    const treffer = schluessel.match(/^properties\[(.+)\]$/);
    if (treffer && typeof wert === 'string' && wert.trim() !== '') {
      eigenschaften[treffer[1]] = wert;
    }
  }
  return eigenschaften;
}

// Baut aus dem Original-Formular eine Anfrage mit beiden Positionen.
function kombinierteAnfrage(formData, text, anzahl) {
  const kerzenId = formData.get('id');
  const kerzenMenge = Number(formData.get('quantity')) || 1;
  const abschnitte = formData.getAll('sections').filter(Boolean).join(',');
  const sellingPlan = formData.get('selling_plan');

  const kerze = {
    id: kerzenId,
    quantity: kerzenMenge,
    properties: eigenschaftenLesen(formData),
  };
  if (sellingPlan) kerze.selling_plan = sellingPlan;

  const beschriftung = {
    id: BESCHRIFTUNG_VARIANT_ID,
    quantity: anzahl * kerzenMenge,
    properties: { _Für: text.slice(0, 60) },
  };

  const koerper = { items: [kerze, beschriftung] };
  if (abschnitte) koerper.sections = abschnitte;

  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(koerper),
  };
}

// Wir hängen uns an "fetch" – die Funktion, mit der das Theme den
// Artikel an Shopify schickt – und ersetzen die Anfrage durch eine,
// die beide Positionen auf einmal enthält.
function initAutomatischerAufpreis() {
  if (window.__beschriftungHaken) return;
  window.__beschriftungHaken = true;

  const originalFetch = window.fetch;

  window.fetch = function (...args) {
    try {
      const ziel = args[0];
      const optionen = args[1] || {};
      const url = typeof ziel === 'string' ? ziel : ziel && ziel.url ? ziel.url : String(ziel);
      const methode = String(optionen.method || (ziel && ziel.method) || 'GET').toUpperCase();

      if (methode !== 'POST' || !url.includes('/cart/add')) {
        return originalFetch.apply(this, args);
      }

      const formData = optionen.body;
      if (!(formData instanceof FormData)) {
        return originalFetch.apply(this, args);
      }

      const text = formData.get(FELDNAME);
      if (typeof text !== 'string') {
        return originalFetch.apply(this, args);
      }

      const anzahl = zeichenZaehlen(text);
      if (anzahl === 0) {
        console.log(LOG, 'Kein Text eingegeben – nur die Kerze wird hinzugefügt.');
        return originalFetch.apply(this, args);
      }

      console.log(LOG, 'Kerze + Beschriftung werden zusammen gesendet. Zeichen:', anzahl);

      const anfrage = kombinierteAnfrage(formData, text, anzahl);

      return originalFetch
        .call(this, cartAddUrl(), anfrage)
        .then(async (antwort) => {
          // Sicherheitsnetz: Falls Shopify die kombinierte Anfrage ablehnt,
          // schicken wir die ursprüngliche Anfrage nach, damit die Kerze
          // auf jeden Fall im Warenkorb landet.
          let daten = null;
          try {
            daten = await antwort.clone().json();
          } catch (fehler) {
            /* Antwort war kein JSON – wir reichen sie unverändert weiter. */
          }

          if (daten && daten.status) {
            console.warn(LOG, 'Kombinierte Anfrage abgelehnt:', daten.message, '– sende nur die Kerze.');
            return originalFetch.apply(this, args);
          }

          console.log(LOG, 'Kerze und Beschriftung im Warenkorb.');
          return antwort;
        })
        .catch((fehler) => {
          console.error(LOG, 'Kombinierte Anfrage fehlgeschlagen:', fehler, '– sende nur die Kerze.');
          return originalFetch.apply(this, args);
        });
    } catch (fehler) {
      console.error(LOG, 'Unerwarteter Fehler:', fehler);
      return originalFetch.apply(this, args);
    }
  };

  console.log(LOG, 'Automatischer Aufpreis aktiv (Version 5).');
}

/* ------------------------------------------------------------------ */

function start() {
  initPreisvorschau();
  initAutomatischerAufpreis();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}